import { useState, useEffect } from 'react';

export const useCCTVMode = (isMaintenance: boolean): [boolean, () => void] => {
    const [enabled, setEnabled] = useState<boolean>(false);

    useEffect(() => {
        if (enabled && isMaintenance) {
            setEnabled(false);
        }
    }, [enabled, isMaintenance]);

    const toggleCCTVMode = (): void => {
        setEnabled(!enabled);
    };

    return [enabled, toggleCCTVMode];
};
